module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hrms31e"
    }
  }, [_c('hrms-search-box-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.indexDisp),
      expression: "indexDisp"
    }],
    attrs: {
      "data": _vm.index,
      "nowLang": _vm.app.nowLang,
      "unLoadBool": true,
      "columns": _vm.columns[_vm.app.nowLang].index,
      "receivedStore": _vm.receivedHrms31eIndex,
      "editEvent": _vm.editEvent,
      "searchBoxAlias": "hrms31e",
      "callSearchEvent": _vm.callSearchEvent
    },
    model: {
      value: (_vm.searchIndex),
      callback: function($$v) {
        _vm.searchIndex = $$v
      },
      expression: "searchIndex"
    }
  }), _vm._v(" "), _c('detail', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailDisp),
      expression: "detailDisp"
    }],
    attrs: {
      "labels": _vm.labels[_vm.app.nowLang],
      "labelsButton": _vm.app.button[_vm.app.nowLang],
      "indexSelected": _vm.indexSelected,
      "detail": _vm.detail,
      "popupDetail": _vm.popupDetail,
      "nowLang": _vm.app.nowLang,
      "toggle": _vm.toggle,
      "pcDisp": _vm.pcDisp,
      "dropdowns": _vm.dropdowns,
      "postHrms31eSave": _vm.postHrms31eSave,
      "postHrms31eDelete": _vm.postHrms31eDelete,
      "receivedHrms31eDetailSearch": _vm.receivedHrms31eDetailSearch,
      "receivedHrms31eDetailPopup": _vm.receivedHrms31eDetailPopup,
      "receivedHrms31eIndex": _vm.receivedHrms31eIndex,
      "tab3Table1": _vm.columns[_vm.app.nowLang].columnsTab3Table1,
      "tab3Table2": _vm.columns[_vm.app.nowLang].columnsTab3Table2,
      "saveButtonDisp": _vm.saveButtonDisp,
      "setSaveButtonDisp": _vm.setSaveButtonDisp,
      "codeval": _vm.codempid,
      "searchIndex": _vm.searchIndex,
      "descCodeval": _vm.app.currentUser.username[_vm.app.nowLang],
      "postHrms31eSendMail": _vm.postHrms31eSendMail
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-897aac44!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms31e/component.vue
// module id = 3924
// module chunks = 1